module.exports = __webpack_public_path__ + "img/96e26652e91c530332cb90d7908a787c.96e26652.png";